import { FieldTypeLink } from '@allesauto/utils/consts';
import {
  getUrlFromStoryblokLink,
  parseSlashToURL,
} from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import React from 'react';

import VehicleCard, { VehicleCardProps } from './vehicleCard/VehicleCard';
import TextLink from '../textLink';

export interface LatestVehiclesTeaserProps {
  headline: string;
  textLinkText?: string;
  textLinkHref?: FieldTypeLink;
  vehicles: VehicleCardProps[];
  component: string;
  _uid: string;
  _editable?: string;
}

const LatestVehiclesTeaser: React.FC<LatestVehiclesTeaserProps> = (props) => {
  const { headline, vehicles, textLinkHref, textLinkText } = props;

  const url = textLinkHref && getUrlFromStoryblokLink(textLinkHref);
  const lastVehicleTeaserLink = (url && parseSlashToURL(url)) || '';

  const className = {
    wrapper:
      'bg-purple80 monochrome:bg-grey90 pb-40px lg:py-80px pt-60px grid grid-cols-24',
    headline:
      'font-headline break-words text-headline2 text-green60 monochrome:!text-white mb-40px lg:mb-60px col-start-2 col-end-24 lg:col-end-21',
    vehicleList: 'col-start-2 col-end-24 grid grid-cols-1 auto-rows-fr lg:flex',
    textLink:
      'lg:self-end col-end-24 mt-40px lg:mt-0 lg:mb-[4.375rem] col-start-2 lg:col-start-21 lg:row-end-2 lg:row-start-1 lg:justify-self-end',
  };

  return (
    <div {...sbEditable(props)} className={className.wrapper}>
      <div className={className.headline}>{headline}</div>
      <div className={className.vehicleList}>
        {vehicles.map((vehicle, id) => (
          <VehicleCard key={id} {...vehicle} />
        ))}
      </div>
      {textLinkText && textLinkHref && (
        <TextLink
          href={lastVehicleTeaserLink}
          text={textLinkText}
          isDarkBg={true}
          customClassName={className.textLink}
          target={textLinkHref.target ?? '_self'}
        />
      )}
    </div>
  );
};

export default LatestVehiclesTeaser;
